// src/pages/Register.js
import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import slideLogin from "../img/slide-login.jpeg";
import logoDR from "../img/logo-dataregion.png";

export default function Register() {
  const USER_TYPES = [
    "Estudiante",
    "Emprendedor",
    "Empresario",
    "Empleado",
    "Independiente",
  ];

  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    userType: "", // ✅ nuevo campo
  });

  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const nav = useNavigate();

  const handleChange = (field, value) => {
    setForm({ ...form, [field]: value });
    setErrors({ ...errors, [field]: "" });
    setApiError("");
  };

  const submit = async (e) => {
    e.preventDefault();

    // Validación básica
    const newErrors = {};
    if (!form.name.trim()) newErrors.name = "El nombre es obligatorio.";
    if (!form.email.trim()) newErrors.email = "El correo es obligatorio.";
    if (!form.password.trim()) newErrors.password = "La contraseña es obligatoria.";
    if (!form.userType) newErrors.userType = "Selecciona un tipo de usuario."; // ✅ validar select

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      await axios.post("https://back.dataregion.com.co/api/auth/register", form);

      setShowSuccess(true);
      setTimeout(() => nav("/login"), 3000);
    } catch (err) {
      setApiError(err.response?.data?.message || "Error durante el registro.");
    }
  };

  return (
    <>
      {/* POPUP DE ÉXITO */}
      {showSuccess && (
        <div className="popup-overlay">
          <div className="popup-box animate-popup">
            <img src={logoDR} alt="DataRegión" className="popup-logo" />

            <h3>¡Registro exitoso!</h3>
            <p>Tu cuenta ha sido creada correctamente.</p>

            <button className="popup-btn" onClick={() => nav("/login")}>
              Iniciar sesión
            </button>
          </div>
        </div>
      )}

      {/* LAYOUT REGISTRO */}
      <div className="login-container">
        {/* COLUMNA IZQUIERDA */}
        <div
          className="login-left"
          style={{
            backgroundImage: `linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.45)), url(${slideLogin})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="login-left-content">
            <p className="login-left-text">Ciénaga San Silvestre, Barrancabermeja.</p>
          </div>
        </div>

        {/* COLUMNA DERECHA */}
        <div className="login-right">
          <div className="login-form-box">
            <img src={logoDR} alt="DataRegión" className="login-logo-top" />
            <h2 className="login-title">Crear cuenta</h2>
            <p className="subtitle">Regístrate para acceder a DataRegión.</p>

            {apiError && <div className="api-error">{apiError}</div>}

            <form onSubmit={submit} className="login-form">
              <div className="input-group">
                <label>Nombre completo</label>
                <input
                  type="text"
                  className={errors.name ? "error-input" : ""}
                  placeholder="Tu nombre"
                  value={form.name}
                  onChange={(e) => handleChange("name", e.target.value)}
                />
                {errors.name && <p className="error-text">{errors.name}</p>}
              </div>

              <div className="input-group">
                <label>Correo electrónico</label>
                <input
                  type="email"
                  className={errors.email ? "error-input" : ""}
                  placeholder="example@email.com"
                  value={form.email}
                  onChange={(e) => handleChange("email", e.target.value)}
                />
                {errors.email && <p className="error-text">{errors.email}</p>}
              </div>

              {/* ✅ NUEVO SELECT */}
              <div className="input-group">
                <label>Tipo de usuario</label>
                <select
                  className={errors.userType ? "error-input" : ""}
                  value={form.userType}
                  onChange={(e) => handleChange("userType", e.target.value)}
                >
                  <option value="">Selecciona una opción</option>
                  {USER_TYPES.map((t) => (
                    <option key={t} value={t}>
                      {t}
                    </option>
                  ))}
                </select>
                {errors.userType && <p className="error-text">{errors.userType}</p>}
              </div>

              <div className="input-group">
                <label>Contraseña</label>
                <input
                  type="password"
                  className={errors.password ? "error-input" : ""}
                  placeholder="********"
                  value={form.password}
                  onChange={(e) => handleChange("password", e.target.value)}
                />
                {errors.password && <p className="error-text">{errors.password}</p>}
              </div>

              <button className="login-btn" type="submit">
                Crear cuenta
              </button>

              <div className="register-link">
                ¿Ya tienes cuenta?
                <Link to="/login"> Inicia sesión</Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
